export const environment = {
  production: true,
  development: false,
  test: false,
  authorizeProspectBrands: '[\"VYV\", \"HM\", \"MGEN\", \"MNT\"]',
  product: 'PJ',
  brand: 'VYV',
  apiV2RootUrl: 'https://dev.assurance.vyv-conseil.fr/api/',
  baseUrl: 'https://dev.assurance-habitation.vyv-conseil.fr/',
  matomotoKey: 'CHANGEME',
  appInsightsKey: 'f409faaf-8841-41c5-aa3f-a35a34bc220d',
  assGarantie:
    'https://saboiardbackofficeb3l5w.blob.core.windows.net/public/VYV_Plaquette_Assurance_Protection_Juridique_Tableau%20des%20garanties.pdf',
  matomoSiteId: 6,
  matomoHostUrl: 'https://matomo-recette.vyv-extension-essai.aws.mgen.fr/',
  matomoScriptUrl: 'https://matomo-recette.vyv-extension-essai.aws.mgen.fr/js/container_682wvypB.js',
  msalConfig: {
    auth: {
      clientId: '36c60bd7-87d9-4603-ac31-d5f3a3af8919',
      authority: 'https://login.microsoftonline.com/6f12f368-4cb1-4b07-9574-dd2cdf95d9c1',
      redirectUri:
        'https://dev.assurance-protection-juridique.vyv-conseil.fr/',
    },
  },
  apiConfig: {
    scopes: ['api://boiard-dev-back-office/Read.All', 'api://boiard-dev-back-office/Write.All'],
    uri: 'https://dev.assurance.vyv-conseil.fr/api/',
  },
  url_espace_adherent: 'https://dev.assurance.vyv-conseil.fr/mon-espace/',
  googleTagManagerId: 'GTM-M2XCS4XC',
  skeepersTagId: '0ca9a77d9faddd0653a92063233c1633-3968',
};
